// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__internal__SearchFilter__root","toolbar":"CentricUI__internal__SearchFilter__toolbar","searchInput":"CentricUI__internal__SearchFilter__searchInput","sectionDropdown":"CentricUI__internal__SearchFilter__sectionDropdown","loader":"CentricUI__internal__SearchFilter__loader"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/internal/filters/components/internal/SearchFilter.css
// module id = 1007
// module chunks = 10